<template>
  <div class="StuTM3">
    <div
      class="basics_info PstuInfo"
      @mouseover="showBasicsInfoEdit = true"
      @mouseleave="showBasicsInfoEdit = false"
    >
      <div
        class="basics_info_edit"
        @click.stop="handleBasicsEdit"
        v-show="showBasicsInfoEdit"
      >
        <i
          class="el-icon-edit-outline"
          style="font-size: 18px; color: #fff"
        ></i>
      </div>
      <div class="substudentContainer" >
        <div
          v-for="(item, index) in basicsCheckList"
          :key="index"
          class="substudentContainer-item"
        >
            <div
              v-if="index == 0"
              class="substudentItem"
            >
              <div class="substudentItem-class i-name">{{ item }}</div>
              <div class="substudentItem-area i-cont"></div>
            </div>
            <div
              v-else-if="index == 1"
              class="substudentItem"
            >
              <div class="substudentItem-class i-name">{{ item }}</div>
              <div class="substudentItem-area i-cont"></div>
            </div>
          <div v-else class="substudentItem">
            <div class="substudentItem-class i-name">{{ item }}</div>
            <div class="substudentItem-area i-cont"></div>
          </div>
        </div>
        <!---->
      </div>
      <!---->
    </div>
    <ModalBasicsEdit v-model="modalBasicsEditV" />
  </div>
</template>
<script>
import ModalBasicsEdit from "../../views/components/card/modal-basics-info";
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      modalBasicsEditV: false,
      showBasicsInfoEdit: false,
    };
  },
  components: {
    ModalBasicsEdit,
  },
  computed: {
    ...mapState("card", {
      basicsCheckList: (state) => state.basicsCheckList, //选中的信息
    }),
  },
  methods: {
    handleBasicsEdit() {
      this.modalBasicsEditV = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.PstuInfo {
  position: relative;
  .substudentContainer {
    height: 50px;
    width: 100%;
    border: 1px solid #000000;
    display: flex;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;
    &-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;
      position: relative;
      flex: 1;
    }
    .substudentItem {
      font-size: 13px;
      flex: 1;
      display: flex;
      padding-left: 10px;
      padding-right: 10px;
      color: var(--card-color);
      &-class {
        margin-top: 4px;
        font-weight: 700;
      }
      &-area {
        flex: 1;
        margin-left: 5px;
        padding-top: 30px;
        border-bottom: 1px solid #000000;
      }
    }
  }
  .basics_info_edit {
  position: absolute;
  display: flex;
  width: 30px;
  height: 30px;
  top: 7px;
  right: 7px;
  background: #409eff;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  box-shadow: 2px 2px 6px #3031339e;
  cursor: pointer;
  z-index: 1;
}
}
</style>